import { useEffect, useState } from "react";

export default function OtpActions({
  onChangeTarget,
  onResend,
  loading,
  changeLabel = "Change number",
}) {
  const [left, setLeft] = useState(30);

  useEffect(() => {
    const t = setInterval(() => setLeft((n) => Math.max(0, n - 1)), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="flex items-center justify-between gap-3 text-sm">
      <button type="button" className="text-[#673c96] font-semibold" onClick={onChangeTarget} data-testid="otp-change-target">
        {changeLabel}
      </button>
      <button
        type="button"
        disabled={left > 0 || loading}
        className="text-[#f37721] font-semibold disabled:text-[#9ca3af]"
        data-testid="otp-resend"
        onClick={async () => {
          await onResend?.();
          setLeft(30);
        }}
      >
        {left > 0 ? `Resend in ${left}s` : "Resend OTP"}
      </button>
    </div>
  );
}
